import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicHome from "@/pages/PublicHome";
import AdminLogin from "@/pages/AdminLogin";
import AdminForgotPassword from "@/pages/AdminForgotPassword";
import AdminResetPassword from "@/pages/AdminResetPassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminLive from "@/pages/admin/AdminLive";
import AdminCultes from "@/pages/admin/AdminCultes";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminAnnouncements from "@/pages/admin/AdminAnnouncements";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminChurchInfo from "@/pages/admin/AdminChurchInfo";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminRegistrations from "@/pages/admin/AdminRegistrations";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-deepblue-900">
        <div className="animate-pulse font-serif text-2xl">Chargement…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<PublicHome />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
            <Route path="/admin/reset-password" element={<AdminResetPassword />} />
            <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
              <Route index element={<AdminOverview />} />
              <Route path="live" element={<AdminLive />} />
              <Route path="cultes" element={<AdminCultes />} />
              <Route path="events" element={<AdminEvents />} />
              <Route path="announcements" element={<AdminAnnouncements />} />
              <Route path="messages" element={<AdminMessages />} />
              <Route path="registrations" element={<AdminRegistrations />} />
              <Route path="church" element={<AdminChurchInfo />} />
              <Route path="users" element={<AdminUsers />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
